import React, {useEffect, useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import Modal from "react-modal";

const ShowProductModal = (props) => {
    const {
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => { },
        productId   = null,
        id          = "show-product-modal",
    } = props;

    const [product, setProduct] = useState(null);

    useEffect(() => {
        if (!!productId) {
            load();
        }
    }, [productId]);

    const load = () => {
        axios.get(route('web-api.product.show', {product: productId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.product) {
                        setProduct(response.data.product);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const renderNoItems = () => {
        return (
            <div className={"line-item-row empty"}>
                <span>No Line Items</span>
            </div>
        )
    }

    const renderLineItemRow = (index, item) => {
        return (
            <div className={"line-item-row"} key={item.id}>
                <div className="column name-column">
                    <p className={"m-0"}>{item.name}</p>
                </div>
                <div className="column detail-column">
                    <p className={"m-0"}>{item.detail}</p>
                </div>
            </div>
        );
    }

    const renderLineItems = () => {
        const lineItems = product.product_line_items;

        return (
            <div className={"m-0 product-line-items-table"}>
                <div className={"line-item-table"}>
                    <div className="header">
                        <div className="column name-column">
                            <span>Line Item</span>
                        </div>
                        <div className="column detail-column">
                            <span>Quantity</span>
                        </div>
                    </div>
                    {!!lineItems && lineItems.length > 0 ? lineItems.map((item, index) => renderLineItemRow(index, item)) : renderNoItems()}
                </div>
            </div>
        );
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => onCancel()}
            contentLabel="Product Information"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal wide-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Product Information</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => onCancel()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    {!!product && (
                        <React.Fragment>
                            <div className="row m-0 p-0">
                                <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Product Reference</strong></p>
                                    <p className="text-eh-off-black">{!!product.reference ? product.reference : "-"}</p>
                                </div>
                                <div className="col-12 col-md-6 m-0 p-0 pl-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Product Name</strong></p>
                                    <p className="text-eh-off-black">{!!product.name ? product.name : "-"}</p>
                                </div>
                            </div>
                            <div className="row m-0 p-0">
                                <div className="col-12 col-md-6 m-0 p-0 pr-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Product Type</strong></p>
                                    <p className="text-eh-off-black">{!!product.product_type_name ? product.product_type_name : "-"}</p>
                                </div>
                                <div className="col-12 col-md-6 m-0 p-0 pl-md-2">
                                    <p className="mb-0 text-eh-off-black"><strong>Quantity</strong></p>
                                    <p className="text-eh-off-black">{!!product.quantity ? product.quantity : "-"}</p>
                                </div>
                            </div>
                            <div className="row m-0 mb-3 p-0">
                                <div className="col-12 m-0 p-0">
                                    <p className="mb-0 text-eh-off-black"><strong>Description</strong></p>
                                    <p className="text-eh-off-black">{!!product.description ? product.description : "-"}</p>
                                </div>
                            </div>
                            {renderLineItems()}
                        </React.Fragment>
                    )}
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => onCancel()}
                    >
                        {"Close"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ShowProductModal;
